import arrayMove from 'array-move';
import { AddToAnyViewModel } from 'stageclip-common';

import { PortalsPageState } from './PortalsPage.types';

export type OperationType = 'increment' | 'decrement';

export const setSocialMediaButtonsOrder = (
  socialMediaButton: AddToAnyViewModel,
  indexOfPreviousButtonPosition: number,
  indexOfCurrentButtonPosition: number,
  type: OperationType,
) => {
  const movedElement = indexOfPreviousButtonPosition === indexOfCurrentButtonPosition;
  const whichElementIsAfflicted =
    type === 'increment' ? indexOfCurrentButtonPosition + 1 : indexOfCurrentButtonPosition - 1;
  const afflictedElement = indexOfPreviousButtonPosition === whichElementIsAfflicted;

  if (movedElement) {
    return {
      ...socialMediaButton,
      order: type === 'increment' ? socialMediaButton.order - 1 : socialMediaButton.order + 1,
    };
  }

  if (afflictedElement) {
    return {
      ...socialMediaButton,
      order: type === 'increment' ? socialMediaButton.order + 1 : socialMediaButton.order - 1,
    };
  }

  return { ...socialMediaButton };
};

export const setStateOfSocialMediaButtons = (
  prevState: PortalsPageState,
  idOfButtonToMove: string,
  type: OperationType,
) => {
  const indexOfElement = prevState.socialMediaButtons.findIndex(socialButton => socialButton.id === idOfButtonToMove);

  const isTryingToMoveFirstHigher = type === 'increment' && indexOfElement === 0;
  const isTryingToMoveLastLower = type === 'decrement' && indexOfElement === prevState.socialMediaButtons.length - 1;

  if (isTryingToMoveFirstHigher || isTryingToMoveLastLower) {
    return { ...prevState };
  }

  return {
    ...prevState,
    socialMediaButtons: arrayMove(
      prevState.socialMediaButtons.map((socialButton, i) =>
        setSocialMediaButtonsOrder(socialButton, indexOfElement, i, type),
      ),
      indexOfElement,
      type === 'increment' ? indexOfElement - 1 : indexOfElement + 1,
    ),
  };
};

export const satisfiesSearchQuery = (column: string, searchQuery: string) => {
  const filterWords = searchQuery
    .toString()
    .toLowerCase()
    .split(' ');

  const valueToFilter = column.toString().toLowerCase();

  return filterWords.every(word => valueToFilter.includes(word));
};

export const getPrefixFromPortalsSubdomain = (subdomain: string) =>
  subdomain.endsWith(process.env.REACT_APP_PORTALS_DOMAIN)
    ? subdomain.substr(0, subdomain.length - process.env.REACT_APP_PORTALS_DOMAIN.length - 1)
    : subdomain;
